module.exports = "/static/assets/11fabbdd1bc0ff364d4c110e60db2287.gif";